import i18n from "../../../config/dictionary/i18n";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

const checkValueWithInterval = (inputValue: any, min: number, max: number) => {
    let formattedValue;
    if (inputValue === "") {
        return inputValue;
    } else if (inputValue > max) {
        formattedValue = "" + max;
    } else if (inputValue < min) {
        formattedValue = "" + min;
    } else {
        formattedValue = "" + inputValue;
    }
    return formattedValue
}

const stringToBool = (s: string) => {
    return s.toLowerCase() === 'y';
}

const boolToString = (b: boolean) => {
    return b ? 'y' : 'n';
}

const stringToInt = (s: string) => {
    return 'Si' || 'Yes' ? 1 : 0;
}
const cleanObject = (obj: any) => {
    for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined || obj[propName] === ''){
            delete obj[propName];
        }
    }
    return obj
}

const intToFloatCurrency= (val : string )=>{
    return (parseInt(val) / 100).toLocaleString(localStorage.getItem('i18nextLng') || 'en');
}

export const stringToIntValue = (val : string )=>{
    return parseInt(val).toLocaleString(localStorage.getItem('i18nextLng') || 'en');
}

const floatToIntCurrency = (val : string)=>{
    let num = parseFloat(val.replace(',','.'));
    return (num * 100).toFixed(0);
}
export const floatToIntAmount = (val : any)=>{
    let num = parseFloat(val.replace(',','.'));
    return (Number((num * 100).toFixed(2)));
}
export function formatToFloat(number: number, multiplier: number){
    return (number * multiplier).toFixed(2)
}
const handleChangeCustomer = (value: any,setSelectedCustomer:any,setValue:any,trigger:any,formState:any) => {
    setSelectedCustomer(value ? value : "");
    setValue("customerId", value ? value.value : "");
    if(value && value.value){
        trigger('customerId')
    } else if (formState.isSubmitted) {
        trigger('customerId')
    }
}

const limitAfterDot = (inputString:string, limit:number) => {
    const dotIndex = inputString.indexOf('.');
    const substringAfterDot = inputString.substring(dotIndex + 1);
    const limitedSubstring = substringAfterDot.slice(0, limit);
    return inputString.substring(0, dotIndex + 1) + limitedSubstring;
    
  }

const downloadTemplate = (donwloadTemplate:()=>Promise<any>,dispatchGlobalData:({type,payload}:any) => void,setSnackbar:any,snackbarTypes:any,snackbarErrorMesageType:string) => {
    donwloadTemplate().then(response => {
        // create file link in browser's memory
        var binaryData = [];
        binaryData.push(response);
        const href = URL.createObjectURL(new Blob(binaryData));

        // create "a" HTML element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', 'template.xlsx');
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    }).catch(e => {
        console.error(e);
        dispatchGlobalData({
            type: setSnackbar,
            payload: {
                snackbar: {
                    message: snackbarErrorMesageType ,
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                }
            }
        });
    })
  }


export {checkValueWithInterval, stringToBool, boolToString, cleanObject, floatToIntCurrency, intToFloatCurrency,handleChangeCustomer,limitAfterDot,downloadTemplate,stringToInt}
export function formatCurrency(number: number, currency: string = 'EUR', multiplier: number = 1) {
    if (number === null || number === undefined || Number.isNaN(number)) {
        return "---";
    }
    return new Intl.NumberFormat(i18n.language, { style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol' }).format(number * multiplier);
}

export function formatDate(date: Date) {
    const dateToConvert = dayjs.utc(date, "YYYY-MM-DDTHH:mm:ssZ");
    return dateToConvert.local().format('L LT');
}

export function adaptDateTimeForDateTimePicker(date: Date) {
    return dayjs(formatDate(date), "L LT").toDate();
}

export function adaptDateTimeForDateTimePickerWithTimeZone(date: Date) {
    return dayjs.utc(date).local().format('YYYY-MM-DD HH:mm:ss');
}


